import Vue from 'vue';
import RoPersonSearch from './RoPersonSearch';

Vue.component('RoPersonSearch', RoPersonSearch);

export default RoPersonSearch;



// WEBPACK FOOTER //
// ./scripts/ro-person-search/index.js